import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 55;

export const migration_54_55:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface && designState.surface.pages )
        {
            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                if( page.artboard && page.artboard.allBoxes )
                {
                    Object.values(page.artboard.allBoxes).forEach((boxSnapshot:any) =>
                    {
                        const {component} = boxSnapshot;

                        if( component.name === 'TextInput' )
                        {
                            const {componentDesc} = boxSnapshot;

                            Object.values(componentDesc._properties).forEach((property:any) =>
                            {
                                if( property.name === 'model' )
                                {
                                    property._value = {
                                        ...property._value,
                                        padding: getDefaultPadding(),
                                    };
                                }
                            });
                        }
                    });
                }
            });
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};

function getDefaultPadding()
{
    return {
        'top': {
            'value': {
                '__type': 'NUMBER',
                'value': 0
            },
            'unitsType': {
                '__type': 'STRINGENUM',
                'selectedValue': 'px',
                'values': [
                    'px',
                    '%',
                    'auto'
                ]
            }
        },
        'right': {
            'value': {
                '__type': 'NUMBER',
                'value': 10
            },
            'unitsType': {
                '__type': 'STRINGENUM',
                'selectedValue': 'px',
                'values': [
                    'px',
                    '%',
                    'auto'
                ]
            }
        },
        'bottom': {
            'value': {
                '__type': 'NUMBER',
                'value': 0
            },
            'unitsType': {
                '__type': 'STRINGENUM',
                'selectedValue': 'px',
                'values': [
                    'px',
                    '%',
                    'auto'
                ]
            }
        },
        'left': {
            'value': {
                '__type': 'NUMBER',
                'value': 10
            },
            'unitsType': {
                '__type': 'STRINGENUM',
                'selectedValue': 'px',
                'values': [
                    'px',
                    '%',
                    'auto'
                ]
            }
        }
    };
}
